import React from "react";
import { Col, Row } from "react-bootstrap";
import "./footer.css";

function Footer() {
  return (
    <footer className="bg-primary p-1">
      <div className="container">
        <Row>
          <Col sm={6} lg={12} className="text-center">
            <span className="text-white text-center text-sm-left d-block d-sm-inline-block">
              Copyright © 2024-2026 Yozy Technologies. All rights reserved.
            </span>
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
